import * as React from "react";
import { 
  useRecordContext,
  List,
  Show, 
  SimpleShowLayout, 
  // SimpleForm, 
  // TextInput, 
  Datagrid, 
  TextField,
  //ReferenceArrayField,
  DateField,
  TabbedShowLayout,
  Tab,
  //ReferenceManyField,
  //ReferenceField,
  NumberField,
  //Labeled,
  //ShowContextProvider,
  //useShowController,
  //ShowView,
  //DateTimeInput,
} from 'react-admin';

const DevTitle = () => {
  const record = useRecordContext();
  return <span>Устройство: {record ? `"${record.id}"` : ''}</span>;
}

export const DevList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick="show">
        <TextField source="imei" label="IMEI" />
        <TextField source="id" label="ID" />
        {/* <TextField source="hardware" label="HW" />
        <TextField source="software" label="SW" />
        <TextField source="hdop" label="HDOP" />
        <TextField source="status" label="STATUS" />
        <TextField source="status_ext" label="EXT_STATUS" /> */}
      </Datagrid>
    </List>
  );
}

export const DevShow = (props) => {
  return (
    <Show title={<DevTitle />} {...props}>
      <SimpleShowLayout>
        <TabbedShowLayout>
          <Tab label="Информация">
            <TextField label="IMEI" source="imei" />
            <TextField label="Версия оборудования" source="hardware" />
            <TextField label="Версия программы" source="software" />
            <TextField label="HDOP" source="hdop" />
            <TextField label="Статус" source="status" />
            <TextField label="Расширенный статус" source="status_ext" />

            {/* <ReferenceField label="Навигационное время" source="id" reference="galileo" showTime >
                <DateField source="navigation_timestamp" />
            </ReferenceField>
            <ReferenceField label="Время выхода на связь" source="id" reference="galileo" showTime >
                <DateField source="received_timestamp" />
            </ReferenceField>
            <ReferenceField label="IMEI" source="id" reference="galileo">
                <TextField source="imei" />
            </ReferenceField>
            <ReferenceField label="Пробег (м.)" source="id" reference="galileo">
                <NumberField source="run" />
            </ReferenceField>
            <ReferenceField label="Широта" source="id" reference="galileo">
                <NumberField source="latitude" options={{ maximumFractionDigits: 6 }} />
            </ReferenceField>
            <ReferenceField label="Долгота" source="id" reference="galileo">
                <NumberField source="longitude" options={{ maximumFractionDigits: 6 }} />
            </ReferenceField> */}
          </Tab>
          <Tab label="Последние данные">
            <DateField label="Время" source="ts" showTime locales="ru-RU" options={{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'  }} />
            <NumberField label="Широта" source="latitude" options={{ maximumFractionDigits: 6 }} />
            <NumberField label="Долгота" source="longitude" options={{ maximumFractionDigits: 6 }} />
            <NumberField label="Курс" source="course" />
            <NumberField label="Скорость" source="speed" />
            <NumberField label="Высота" source="height" />
            <NumberField label="Количество спутников" source="nsat" />
            <NumberField label="Напряжение питания" source="supvolt" />
            <NumberField label="Батарея" source="batteryvolt" />
            <NumberField label="ДУТ-0" source="dut0" />
            <NumberField label="ДУТ-1" source="dut1" />
            <NumberField label="ДУТ-2" source="dut2" />
            <NumberField label="ДУТ-3" source="dut3" />
            <NumberField label="ДУТ-3-Температура" source="dut3_temperature" />
            <NumberField label="ДУТ-4" source="dut4" />
            <NumberField label="ДУТ-4-Температура" source="dut4_temperature" />
            <NumberField label="ДУТ-5" source="dut5" />
            <NumberField label="ДУТ-5-Температура" source="dut5_temperature" />
            <NumberField label="ДУТ-6" source="dut6" />
            <NumberField label="ДУТ-6-Температура" source="dut6_temperature" />
            <NumberField label="ДУТ-7" source="dut7" />
            <NumberField label="ДУТ-7-Температура" source="dut7_temperature" />
            <NumberField label="ДУТ-8" source="dut8" />
            <NumberField label="ДУТ-8-Температура" source="dut8_temperature" />
            <NumberField label="ДУТ-9" source="dut9" />
            <NumberField label="ДУТ-9-Температура" source="dut9_temperature" />
            <NumberField label="ДУТ-10" source="dut10" />
            <NumberField label="ДУТ-10-Температура" source="dut10_temperature" />
            <NumberField label="ДУТ-11" source="dut11" />
            <NumberField label="ДУТ-11-Температура" source="dut11_temperature" />
            <NumberField label="ДУТ-12" source="dut12" />
            <NumberField label="ДУТ-12-Температура" source="dut12_temperature" />
            <NumberField label="ДУТ-13" source="dut13" />
            <NumberField label="ДУТ-13-Температура" source="dut13_temperature" />
            <NumberField label="ДУТ-14" source="dut14" />
            <NumberField label="ДУТ-14-Температура" source="dut14_temperature" />
            <NumberField label="ДУТ-15" source="dut15" />
            <NumberField label="ДУТ-15-Температура" source="dut15_temperature" />
            <NumberField label="Температура" source="temperature" />
            <NumberField label="Пробег" source="run" />
            <NumberField label="Правильность определения координат" source="isvalid" />
            <NumberField label="modbus" source="modbus" />
            <NumberField label="bluetooth" source="bluetooth" />
            <NumberField label="Пакет данных" source="fullpkg" />

            <NumberField label="can16bitr0" source="can16bitr0" />
            <NumberField label="can16bitr1" source="can16bitr1" />
            <NumberField label="can16bitr2" source="can16bitr2" />
            <NumberField label="can16bitr3" source="can16bitr3" />
            <NumberField label="can16bitr4" source="can16bitr4" />
            <NumberField label="can16bitr5" source="can16bitr5" />
            <NumberField label="can16bitr6" source="can16bitr6" />
            <NumberField label="can16bitr7" source="can16bitr7" />
            <NumberField label="can16bitr8" source="can16bitr8" />
            <NumberField label="can16bitr9" source="can16bitr9" />
            <NumberField label="can16bitr10" source="can16bitr10" />
            <NumberField label="can16bitr11" source="can16bitr11" />
            <NumberField label="can16bitr12" source="can16bitr12" />
            <NumberField label="can16bitr13" source="can16bitr13" />
            <NumberField label="can16bitr14" source="can16bitr14" />
            <NumberField label="can32bitr0" source="can32bitr0" />
            <NumberField label="can32bitr1" source="can32bitr1" />
            <NumberField label="can32bitr2" source="can32bitr2" />
            <NumberField label="can32bitr3" source="can32bitr3" />
            <NumberField label="can32bitr4" source="can32bitr4" />
            <NumberField label="can32bitr5" source="can32bitr5" />
            <NumberField label="can32bitr6" source="can32bitr6" />
            <NumberField label="can32bitr7" source="can32bitr7" />
            <NumberField label="can32bitr8" source="can32bitr8" />
            <NumberField label="can32bitr9" source="can32bitr9" />
            <NumberField label="can32bitr10" source="can32bitr10" />
            <NumberField label="can32bitr11" source="can32bitr11" />
            <NumberField label="can32bitr12" source="can32bitr12" />
            <NumberField label="can32bitr13" source="can32bitr13" />
            <NumberField label="can32bitr14" source="can32bitr14" />
          </Tab>
          {/* <Tab label="Трек">
            <ReferenceField label="sss" source="imei" reference="track">
              <TextField source="imei" />
            </ReferenceField>
            <ReferenceField label="sss" source="imei" reference="track">              
              <DateTimeInput source="sd" />
            </ReferenceField>
            <ReferenceField label="sss" source="imei" reference="track">              
              <DateTimeInput source="ed" />
            </ReferenceField>
          </Tab> */}
        </TabbedShowLayout>
      </SimpleShowLayout>
    </Show>
  )
}
